import React from 'react'
import ReactHtmlParser from 'react-html-parser'; 
import useSearch from '../../../context/search/useSearch';

interface ISearchResultsSuggestionsComponent {
  dataSet: DOMStringMap
}

const SearchResultsSuggestions: React.FunctionComponent<ISearchResultsSuggestionsComponent> = ({ dataSet }): JSX.Element => {

  const {
    langTitle
  } = dataSet

  const {quickSearchResultsSuggestions } = useSearch()

  // const handleOnClickSuggestion = (index) => eventHandlers.handleSearchSuggestionSelected(index)

  if (quickSearchResultsSuggestions && !quickSearchResultsSuggestions.length) return null

  return (
    <React.Fragment>
      <div className={`sf-results sf-results-suggestions ${(quickSearchResultsSuggestions && quickSearchResultsSuggestions.length) && 'sf-results-loaded'}`}>
        {(quickSearchResultsSuggestions && quickSearchResultsSuggestions.length) &&
        <React.Fragment>
          {langTitle && <div className={'sf-results-title'}>{langTitle}</div>}

          <div className={'sf-results-suggestions-items'}>
            {quickSearchResultsSuggestions.map((suggestion, index) => {

              return (
                <div className={'sf-results-suggestions-item'} key={index}>
                  {/* Canonical search URL: lower-cased term + type=product — see useSearch.tsx */}
                  <a href={`/search?q=${suggestion.query.toLowerCase()}&type=product`} >{ ReactHtmlParser(suggestion.value) }</a>
                </div>
              )
            })}
          </div>
        </React.Fragment>}
      </div>
    </React.Fragment>
  )
}

export default SearchResultsSuggestions